import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Chip from '@material-ui/core/Chip';
import camelize from '@afosto/utils/string/camelize';
import * as defaultRenderers from '../FiltersField/renderers';

const Filter = ({ filter, name, renderers, translationKey }) => {
  const intl = useIntl();
  const { type } = filter ?? {};
  const availableRenderers = { ...defaultRenderers.default, ...renderers };
  const FilterRenderer = availableRenderers[type] ?? availableRenderers.default;

  const renderFilter = (key, operator, value) => (
    <Chip
      style={{ marginTop: 4, marginRight: 4 }}
      label={
        <FilterRenderer
          name={
            name ||
            intl.formatMessage({
              id: `${translationKey}.${camelize(key)}`,
              defaultMessage: camelize(key),
              description: `Label for filter property ${key}`,
            })
          }
          operator={operator}
          value={value}
          renderSettings={{ shorthandOperator: true }}
        />
      }
    />
  );

  if (['in', 'not_in'].includes(filter?.operator)) {
    return (filter?.values ?? []).map(filterValue =>
      renderFilter(filter?.key, filter?.operator === 'in' ? 'is' : 'not_is', [filterValue]),
    );
  }

  return <>{renderFilter(filter.key, filter.operator, filter.values)}</>;
};

Filter.propTypes = {
  filter: PropTypes.object,
  name: PropTypes.string,
  renderers: PropTypes.object,
  translationKey: PropTypes.string,
};

Filter.defaultProps = {
  filter: undefined,
  name: undefined,
  renderers: {},
  translationKey: 'properties',
};

export default Filter;
